export const toCleanString = (value) => {
  if (typeof value !== 'string') {
    value = String(value ?? '');
  }
  return value.trim();
};

export const extractDigits = (value) => {
  return toCleanString(value).replace(/\D/g, '');
};

export const extractLetters = (value) => {
  return toCleanString(value).replace(/[^a-zA-Z]/g, '');
};

export const extractAlphanumerics = (value) => {
  return toCleanString(value).replace(/[^a-zA-Z0-9]/g, '');
};

export const removeAccents = (value) => {
  return toCleanString(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
};

const dateOptions = { 
  year: 'numeric', 
  month: '2-digit', 
  day: '2-digit',
  timeZone: 'UTC'
};

const formatters = {
  'pt-BR': new Intl.DateTimeFormat('pt-BR', dateOptions),
  'en-US': new Intl.DateTimeFormat('en-US', dateOptions),
  'iso': new Intl.DateTimeFormat('en-CA', dateOptions),
};

export const formatDate = (value, locale = 'pt-BR') => {
  const cleanValue = toCleanString(value);
  if (!cleanValue) return '';

  if (locale === 'pt-BR' && cleanValue.match(/^\d{2}\/\d{2}\/\d{4}/)) return cleanValue.slice(0, 10);
  if (locale === 'iso' && cleanValue.match(/^\d{4}-\d{2}-\d{2}/)) return cleanValue.slice(0, 10);

  let date;
  if (cleanValue.includes('/')) {
    const [day, month, year] = cleanValue.split('/');
    date = new Date(Date.UTC(year, month - 1, day));
  } else {
    date = new Date(cleanValue);
  }

  if (isNaN(date.getTime())) return '';

  return formatters[locale].format(date);
};

export const toBrazilianDate = (value) => formatDate(value, 'pt-BR');
export const toISODate = (value) => formatDate(value, 'iso');

const format = {
  toCleanString,
  extractDigits,
  extractLetters,
  extractAlphanumerics,
  removeAccents,
  toBrazilianDate,
  toISODate,
  formatDate,
};

export default format;